export const commonEN = {
  '/': '/',
  '-': '-',
  '#': '#',
  '%': '%',
  '+': '+',
  RT: 'RT',
  And: 'And',
  Fee: 'Fee',
  Due: 'Due',
  Min: 'Min',
  Max: 'Max',
  Tax: 'Tax',
  Buy: 'Buy',
  Sell: 'Sell',
  Back: 'Back',
  Name: 'Name',
  Unit: 'Unit',
  Date: 'Date',
  Home: 'Home',
  Risk: 'Risk',
  Info: 'Info',
  Enter: 'Enter',
  Group: 'Group',
  Woops: 'Woops',
  Apply: 'Apply',
  Items: 'Items',
  Close: 'Close',
  Fixed: 'Fixed',
  Place: 'Place',
  Print: 'Print',
  Reset: 'Reset',
  State: 'State',
  Total: 'Total',
  Input: 'Input',
  Region: 'Region',
  Search: 'Search',
  Cancel: 'Cancel',
  Output: 'Output',
  Amount: 'Amount',
  Status: 'Status',
  Number: 'Number',
  Buying: 'Buying',
  Selling: 'Selling',
  Minimal: 'Minimal',
  Maximal: 'Maximal',
  Deposit: 'Deposit',
  Country: 'Country',
  History: 'History',
  Details: 'Details',
  Loading: 'Loading',
  Offsets: 'Offsets',
  Balance: 'Balance',
  Proceed: 'Proceed',
  Dismiss: 'Dismiss',
  Success: 'Success',
  Terminals: 'Terminals',
  Discount: 'Discount',
  Optional: 'Optional',
  Continue: 'Continue',
  Operator: 'Operator',
  Function: 'Function',
  Currency: 'Currency',
  Password: 'Password',
  Range_to: 'Range to',
  Total_fee: 'Total fee',
  Recipient: 'Recipient',
  Calculate: 'Calculate',
  Reference: 'Reference',
  Is_active: 'Is_active',
  Percentage: 'Percentage',
  Activated_on: 'Activated on',
  Deactivated_on: 'Deactivated on',
  Date_time: 'Date time',
  For_agent: 'For agent',
  For_client: 'For client',
  For_location: 'For location',
  Range_from: 'Range from',
  Created_at: 'Created at',
  Updated_at: 'Updated at',
  Max_length: 'Max length of field is ',
  Model_name: 'Model name',
  Model_unit: 'Model unit',
  Date_to: 'Date to',
  Date_from: 'Date from',
  Model_type: 'Model type',
  General_tab: 'General tab',
  Location_id: 'Location id',
  Description: 'Description',
  Denomination: 'Denomination',
  Total_amount: 'Total amount',
  Seconds_left: 'Seconds left',
  Master_agent: 'Master agent',
  Is_leap_year: 'Is leap year',
  Service_type: 'Service type',
  Service_code: 'Service code',
  Currency_code: 'Currency code',
  Currency_name: 'Currency name',
  State_changes: 'State changes',
  Save_template: 'Save template',
  Account_number: 'Account number',
  Currency_type: 'Currency type',
  Required_field: 'This field is required',
  Document_number: 'Document number',
  Time_is_up_soon: 'Time is up soon',
  General_details: 'General details',
  Successful_copy: 'Successful copy',
  Rejection_reason: 'Rejection reason',
  Platform_service: 'Platform service',
  Reference_number: 'Reference number',
  Invalid_password: 'Invalid password',
  No_options_found: 'No options found',
  Domicile_currency: 'Domicile currency',
  Confirm_password: 'Confirm password',
  Successful_withdraw: 'Successful withdraw',
  Options_are_loading: `Options are loading`,
  You_sure_you_want_to_proceed: 'Are you sure you want to proceed?',

  First_working_week_day: 'First_working_week_day',

  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details1`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level_1: `menu level 1`,
  menu_level_2: `menu level 2`,
  menu_level_3: `menu level 3`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  date_from: `date from`,
  date_to: `date to`,
  date_time: `date time`,
  Service_types: `Service types`,
  From_date: `From date`,
  To_date: `To date`,
  Dashboard: `Dashboard`,
  Pricelist: `Pricelist`,
  Update_pricelist: `Update pricelist`,
  Form_configuration: `Form configuration`,
  Auto_save: `Auto save`,
  Using_api: `Using api`,
  Using_mocks: `Using mocks`,
  Last_save: `Last save`,
  Saved: `Saved`,
  No_element_selected: `No element selected`,
  Add_row: `Add row`,
  Action: 'Action',
  View: 'View',
  Delete: 'Delete',
  Edit: 'Edit',
  Value: 'Value',
  Yes: 'Yes',
  No: 'No',
  Agent: 'Agent',
  Client: 'Client',
  Location: 'Location',
  All: 'All',
  Submit: 'Submit',
  Model: 'Model',
  Actions: 'Actions',
  Approve: 'Approve',
  Reject: 'Reject',
  Service: 'Service',
  Activate: 'Activate',
  Deactivate: 'Deactivate',
  To: 'To',
  From: 'From',
  Append: 'Append',
  Settings: 'Settings',
  Start: 'Start',
  End: 'End',
  Category: 'Category',
  Symbol: 'Symbol',
  Countries: 'Countries',
  Denominations: 'Denominations',
  Empty: 'Empty',
  Only_active: 'Only active',
  True: 'True',
  False: 'False',
  Id: 'Id',
  Preview: 'Preview',
  Label: 'Label',
  Choose_field: 'Choose field',
  Account_blacklist: 'Account_blacklist',
  Remove_from_blacklist: 'Remove from blacklist',
  Remove_all_accounts: 'Remove all accounts',
  Agent_id: 'Agent id',
  Payment_method: 'Payment method',
  Payment_methods: 'Payment methods',
  Manage_agent: 'Manage agent',
  Method_id: 'Method id',
  Not_found: 'Not found',
  Phonenumber: 'Phonenumber',
  Position: 'Position',
  Email: 'Email',
  Account: 'Account',
  Finish: 'Finish',
  Unfinish: 'Unfinish',
  Select: 'Select',
  Not_saved: 'Not saved',
  Application: 'Application',
  OperationApplication: 'Operation application',
  Duration: 'Duration',
  Domicile: 'Domicile',
  Duplicate: 'Duplicate',
  Within: 'Within',
  Back_to_list: 'Back to list',
  Add_account_to_blacklist: 'Add account to blacklist',

  // FORM CONFIGURATION
  Mask: 'Mask',
  Format: 'Format',
  Prefix: 'Prefix',
  Is_required: 'Is required',
  Has_default_style: 'Has default style',
  Auto_focus: 'Auto focus',
  Padding_left: 'Padding left',
  Margin_top: 'Margin top',
  Decimal_separator: 'Decimal separator',
  Thousand_separator: 'Thousand separator',
  Allow_leading_zeros: 'Allow leading zeros',
  Allow_empty_formatting: 'Allow empty formatting',
  Initialize_form: 'Initialize form',
  Add_header: 'Add header',
  Container_header: 'Container header',
  Transparent_background: 'Transparent background',
  Delete_container: 'Delete container',

  Image_url: 'Image url',
  Enter_values: 'Enter values',
  Template_priority: 'Template priority',
  Template_data: 'Template data',
  Template_type: 'Template type',
  Template_name: 'Template name',
  Template_group: 'Template group',
  Template_group_type: 'Template group type',
  Templates: 'Templates',
  Bank_id: 'Bank id',
  Bank_account: 'Bank account',
  Bank_constraint: 'Bank constraint',
  Bank_obligations: 'Bank obligations',
  Bank_obligations_table: 'Bank obligations table',
  Add_bank_constraint_statement: 'Add bank constraint statement',
  Delete_constraint: 'Delete constraint',
  Add_constraint: 'Add constraint',
  Delete_selected_templates: 'Delete selected templates',
  Delete_template_groups: 'Delete template groups',
  Group_view: 'Group view',
  For_all_agents: 'For all agents',
  Priority: 'Priority',
  Save_template_group: 'Save template group',

  available: `available`,
  coverage: `coverage`,
  reserved_amount: `reserved amount`,
  waiting_transactions: `waiting transactions`,
  balance: `balance`,
  warning_reserved_money_is_less_then_amount: `warning: reserved money is less then amount`,
  bank_account_exectuion: `bank account exectuion`,
  bank_account_index: `bank account index`,
  home: `home`,
  Operater_Payment_order: `Operater Payment order`,
  Operater_Additional_data: `Operater Additional data`,
  Form_configurators: `Form configurators`,
  Create: `Create`,
  Table_view: `Table view`,
  MANAGEMENT: `MANAGEMENT`,
  CONFIGURATION: `CONFIGURATION`,
  Price_list: `Pricelist`,
  bank_account: `bank account`,
  Service_provider: `Service provider`,
  Show_history: `Show history`,
  Delete_pricelist: `Delete pricelist`,
  Update_pricelist_criteria: `Update pricelist criteria`,
  Assign_to_all_agents: `Assign to all agents`,
  Criteria_updated_successfully: `Criteria updated successfully`,
  This_field_is_required: `This field is required`,
  Finish_setting_criteria: `Finish setting criteria`,
  Finish_forming: `Finish forming`,
  Update_pricelist_items: `Update pricelist items`,
  You_must_provide_value_for_all_criterias: `You must provide value for all criterias`,
  copy_id: `copy id`,
  Save_and_close: `Save and close`,
  Save: `Save`,
  Discard_changes: `Discard changes`,
  Delete_this_element: `Delete this element`,
  Copied_to_clipboard: `Copied to clipboard`,
  Click_to_configure: `Click to configure`,
  Created_at_date_time: `Created at date time`,
  Created_by: `Created by`,
  Updated_by: `Updated by`,
  Send_to_verification: `Send to verification`,
  Payments_method: `Payments method`,
  Blacklist: `Blacklist`,
  Agents: `Agents`,
  Transaction_count_channel_percentage: `Transaction count channel percentage`,
  Transaction_amount_channel: `Transaction amount channel`,
  Define_parameters: `Define parameters`,
  Finish_parametrizing: `Finish parametrizing`,
  No_entered_parameters: 'No entered parameters',
  Add_parameter: 'Add parameter',
  Update_items: `Update items`,
  Go_back: `Go back`,
  Create_sharing_arrangement_model: `Create sharing arrangement model`,
  Create_template: `Create template`,

  Create_model: 'Create model',
  Close_model: 'Close model',
  Update_model: 'Update model',
  Return_for_update: 'Return for update',

  Agent_model: 'Agent model',
  Service_provider_model: 'Service provider model',

  Fee_amount: 'Fee amount',
  Tx_amount: 'TX amount',
  Tx_count: 'TX count',
  Model_items: 'Model items',

  Remove: 'Remove',
  Remove_all: 'Remove all',

  Create_column: 'Create column',
  Create_container: 'Create container',

  /* ---------- */
  /*   Common   */
  /* ---------- */

  /* ---------- */
  /* ONBOARDING */
  /* ---------- */
  Abbreviation: `Abbreviation`,
  AutoCreate: 'Auto create',

  DocumentTypesList: `Document types`,
  CreateDocumentType: `Create document type`,
  UpdateDocumentType: `Update document type`,
  DocumentTypeDetails: `Document type details`,
  SuccessfullyCreatedDocumentType: 'Document type created successfully',
  SuccessfullyUpdatedDocumentType: 'Document type updated successfully',

  AMLScoreList: `AML scores`,
  AMLScoreDetails: `AML score details`,
  CreateAMLScore: `Create AML score`,
  UpdateAMLScore: `Update AML score`,
  NotificationDue: `Notification due (in months)`,
  NotificationChannel: `Notification channel`,
  NotificationsArea: 'Notifications area',
  SuccessfullyCreatedAmlScore: 'Aml score created successfully',
  SuccessfullyUpdatedAmlScore: 'Aml score updated successfully',

  RiskScoreList: `Risk scores`,
  RiskScoreDetails: `Risk score details`,
  CreateRiskScore: `Create risk score`,
  UpdateRiskScore: `Update risk score`,
  SuccessfullyCreatedRiskScore: 'Risk score created successfully',
  SuccessfullyUpdatedRiskScore: 'Risk score updated successfully',

  CountryGroupList: `Country groups`,
  CountryGroupDetails: `Country group details`,
  CreateCountryGroup: `Create country group`,
  UpdateCountryGroup: `Update country group`,
  SuccessfullyCreatedCountryGroup: 'Country group successfully created',
  SuccessfullyUpdatedCountryGroup: 'Country group successfully updated',

  PartyTypes: 'Party types',
  CreatePartyType: 'Create party type',
  UpdatePartyType: 'Update party type',
  PartyTypeDetails: 'Party type details',
  SuccessfullyCreatedPartyType: 'Party type successfully created',
  SuccessfullyUpdatedPartyType: 'Party type successfully updated',
  EntityType: 'Entity type',
  EntityFields: 'Create party fields',
  Process: 'Process',
  LEGAL_ENTITY_CONSUMER: 'Legal entity consumer',
  LEGAL_ENTITY_USER: 'Legal entity user',
  LEGAL_ENTITY_CONTACT: 'Legal entity contact',
  PERSON_CONSUMER: 'Person consumer',
  PERSON_USER: 'Person user',
  PERSON_CONTACT: 'Person contact',
  CompletedExpirationDuration: 'Duration in status completed (months)',
  CompletedStatusExpirationNotifyInterval: 'Completed status expiration delivery notify interval',
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  HOURLY: 'Hourly',
  CompletedStatusPeriodNotifyBeforeExpireInDays:
    'Notification delivery period before expiry (days)',
  DeliverViaEmailExpirationNotify: 'Deliver expiration notification via email',
  DeliverViaSmsExpirationNotify: 'Deliver expiration notification via SMS',
  ShowLoginExpirationNotify: 'Show expiration notification on login',
  HasServices: 'Has services',
  HasVideoIdentification: 'Has video identification',

  Processes: 'Processes',
  CreateProcess: 'Create process',
  UpdateProcess: 'Update process',
  ProcessDetails: 'Process details',
  SuccessfullyCreatedProcess: 'Process successfully created',
  SuccessfullyUpdatedProcess: 'Process successfully updated',

  Parties: 'Parties',
  CreateParty: 'Create party',
  UpdatePhysicalPerson: 'Update physical person',
  UpdateLegalEntity: 'Update legal entity',
  PartyDetails: 'Party details',
  PartyType: 'Party type',
  RiskScore: 'Risk score',
  SuccessfullyCreatedParty: 'Party successfully created',
  SuccessfullyUpdatedParty: 'Party successfully updated',

  Document_types: 'Document types',
  Questionnaire_Set: 'Questionnaire set',
  QuestionnaireSets: 'Questionnaire sets',
  CreateQuestionnaireSet: 'Create questionnaire set',
  UpdateQuestionnaireSet: 'Update questionnaire set',
  QuestionnaireSetDetails: 'Questionnaire set details',
  SuccessfullyCreatedQuestionnaireSet: 'Questionnaire set successfully created',
  SuccessfullyUpdatedQuestionnaireSet: 'Questionnaire set successfully updated',
  QuestionnaireType: 'Questionnaire type',
  PreviewQuestionnaire: 'Preview questionnaire',
  FillPartyCase: 'Fill party case',
  Type: 'Type',
  INITIAL_ASSESSMENT: 'Initial assessment',
  CONTROL_ASSESSMENT: 'Control assessment',
  OWNERSHIP_ASSESSMENT: 'Ownership assessment',
  AUTO_PROCESS_ASSESSMENT: 'Auto process assessment',
  Questionnaires: 'Questionnaires',
  RefNumber: 'Ref number',
  HasPersonData: 'Has person data',
  MaxDuration: 'Max duration (minutes)',
  MinPoints: 'Min points',

  QuestionnaireDetails: 'Questionnaire Details',
  CreateQuestionnaire: 'Create questionnaire',
  UpdateQuestionnaire: 'Update questionnaire',
  SuccessfullyUpdatedQuestionnaire: 'Successfully updated questionnaire',
  SuccessfullyCreatedQuestionnaire: 'Successfully created questionnaire',

  UpdateQuestionnaireFields: 'Update questionnaire fields',
  Fields: 'Fields',
  CreateQuestionnaireField: 'Create questionnaire field',
  UpdateQuestionnaireField: 'Update questionnaire field',
  SuccessfullyCreatedQuestionnaireField: 'Field created successfully',
  SuccessfullyUpdatedQuestionnaireField: 'Field updated successfully',
  SuccessfullyDeletedQuestionnaireField: 'Field deleted successfully',
  Identity: 'Identity',
  FieldType: 'Field type',
  HasComment: 'Has comment',
  Mandatory: 'Mandatory',
  Length: 'Length',
  PredefinedRegex: 'Predefined regex',
  RegEx: 'Regex',
  MinValue: 'Minimum value',
  MaxValue: 'Maximum value',
  OutsideRange: 'Outside range',
  ValidationMode: 'Validation mode',
  MinDate: 'Minimum date',
  MaxDate: 'Maximum date',
  MinDateTime: 'Minimal date time',
  MaxDateTime: 'Maximal date time',
  DynamicSource: 'Source',
  Points: 'Points',
  LabelMode: 'Label mode',
  Title: 'Title',
  SubTitle: 'Sub title',
  Collapsible: 'Collapsible',
  Add: 'Add',
  Questionnaire: 'Questionnaire',

  // Questionnaire Field type enum
  STRING: 'Text',
  NUMBER: 'Number',
  DATE: 'Date',
  DATE_TIME: 'Date and time',
  STATIC_LIST: 'Static list',
  DYNAMIC_LIST: 'Dynamic list',
  QUESTION_LIST: 'Question list',
  BOOLEAN: 'Check',
  LABEL: 'Label',
  OWNERSHIP: 'Ownership',
  Expected: 'Expected',

  // Questionnaire field identity enum

  ChangeToForming: 'Change to forming',
  ChangeToPrepared: 'Change to prepared',
  ChangeToVerified: 'Verify',
  ChangeToRejected: 'Reject',
  ChangeToDeleted: 'Delete',
  ChangeToActivated: 'Activate',
  ChangeToClosed: 'Close',
  ChangeToDeactivated: 'Deactivate',
  SuccessfullyChangedQuestionnaireStatus: 'Change status successfully',
  NoEnteredFields: 'No entered fields',

  // Party cases
  PartyCases: 'Party cases',
  PartyCaseType: 'Party case type',
  AmlScore: 'Aml score',
  INITIAL_CASE: 'Initial case',
  CONTROL_CASE: 'Control case',

  DRAFT: 'Draft',
  PENDING: 'Pending',
  SUBMITTED: 'Submitted',
  INITIATED_VIDEO_IDENTIFICATION: 'Initiated video identification',
  APPROVED_VIDEO_IDENTIFICATION: 'Approved video identification',
  REJECTED_VIDEO_IDENTIFICATION: 'Rejected video identification',
  RECEIVED: 'Received',
  PROCESSING_AML: 'Processing AML',
  COMPLETED_AML: 'Completed AML',
  PROCESSING_RISK: 'Processing Risk',
  REJECTED_PROCESSING: 'Rejected processing',
  REJECTED_AML: 'Rejected AML',
  REJECTED_RISK: 'Rejected Risk',
  RE_SUBMITTED: 'Resubmitted',
  COMPLETED: 'Completed',
  EXPIRED: 'Expired',
  DELETE_REQUESTED: 'Delete requested',
  DELETED: 'Deleted',

  ChangeToReceived: 'Change to Received',
  ChangeToProcessingAML: 'Change to Processing AML',
  ChangeToCompletedAML: 'Change to Completed AML',
  ChangeToRejectedAML: 'Change to Rejected AML',
  ChangeToProcessingRisk: 'Change to Processing Risk',
  ChangeToInitiatedVideoIdentification: 'Change to Initiated Video Identification',
  ChangeToApprovedVideoIdentification: 'Change to Approved Video Identification',
  ChangeToRejectedVideoIdentification: 'Change to Rejected Video Identification',
  ChangeToRejectProcessing: 'Change to Reject processing',
  ChangeToCompleted: 'Change to Completed',
  ChangeToRejectedRisk: 'Change to Rejected Risk',
  ChangeToReSubmitted: 'Change to re submitted',
  Template_fields: 'Template fields',

  // Party
  createParty: 'Personal details',
  personalDetails: 'Personal details',
  partyType: 'Party type',
  successFillUserData: 'Successfully filled personal data',
  successUpdatedPartyQuestionnaireData: 'Successfully updated personal details',
  firstName: 'First name',
  lastName: 'Last name',
  questionnaireSet: 'Questionnaire set',
  EndFilling: 'End filling',
  StartFill: 'Start fill',

  // Party case
  SuccessfullySubmittedPartyCase: 'Submitted party case successfully',
  YourPartyCaseWillBeProcessed: 'Your case will be processed',

  // Questionnaire fields
  none: 'None',
  middleName: 'Middle name',
  parentName: 'Parent name',
  personalId: 'Personal ID',
  dateOfBirth: 'Date of birth',
  placeOfBirth: 'Place of birth',
  stateOfBirth: 'State of birth',
  countryOfBirth: 'Country of birth',
  countryOfIdIssue: 'Country of ID issue',
  idNumber: 'ID number',
  idType: 'ID type',
  idIssuer: 'ID issuer',
  idDateOfIssue: 'ID date of issue',
  idExpiryDate: 'ID expiry date',
  idPermanent: 'ID permanent',
  cityOfResidence: 'City of residence',
  zip: 'ZIP',
  countryOfResidence: 'Country of residence',
  mailingAddress: 'Mailing address',
  email: 'Email',
  resident: 'Resident',
  citizenship: 'Citizenship',
  streetName: 'Street name',
  place: 'Place',
  addressType: 'Address type',
  residenceNumber: 'Residence number',
  stateOfResidence: 'State of residence',
  phoneNumber: 'Phone number',
  mobileNumber: 'Mobile number',
  additionalNote: 'Additional note',
  maternalName: 'Maternal name',
  occupation: 'Occupation',

  // PredefinedRegEx enum
  EMAIL: 'Email',
  PHONE: 'Phone',
  JMBG: 'JMBG',
  REGISTRATION_NUMBER: 'Registration number',
  VAT_NUMBER: 'VAT number',
  WEB_PAGE: 'Web page',
  CUSTOM: 'Custom',

  // Validation mode enum
  IN_THE_PAST: 'In the past',
  IN_THE_FUTURE: 'In the future',

  // List dynamic source
  SR_CITY_LIST: 'SR city list',
  COUNTRY_LIST: 'Country list',
  NACE_CODE_LIST: 'NACE code list',
  BUSINESS_TYPE: 'Business type',
  BUSINESS_INDUSTRY: 'Business industry',
  ID_TYPES: 'ID types',
  ADDRESS_TYPES: 'Address types',

  // Question mode enum
  ALL: 'All',
  AT_LEAST_ONE: 'At least one',

  // Label mode
  DESCRIPTION: 'Description',
  TITLE: 'Title',
  SUBTITLE: 'Subtitle',
  TITLE_SUBTITLE: 'Title and subtitle',

  companyName: 'Company name',
  shortName: 'Short name',
  tradeName: 'Trade name',
  typeOfLegalEntity: 'Type of legal entity',
  companyRegistrationNumber: 'Registration number',
  taxNumber: 'Tax number',
  registeredActivity: 'Registered activity',
  registrationDate: 'Registration date',
  stateOfRegistration: 'State of registration',
  countryOfRegistration: 'Country of registration',
  numberOfYearsInBusiness: 'Number of years in business',
  industry: 'Industry',
  registrationAddress: 'Registration address',
  city: 'City',
  postalCode: 'Postal code',
  primaryPhoneNumber: 'Primary phone number',
  webSite: 'Web site',
  ownerType: 'Owner type',
  SOLE_PROPRIETORSHIP: 'Sole proprietorship',
  PRIVATELY_HELD: 'Privately held',
  PUBLICLY_TRADED: 'Publicly traded',
  GOVERNMENT_OWNED: 'Government owned',
  OTHER_HYBRID: 'Other hybrid',
  businessType: 'Business type',
  category: 'Category',
  statisticalGroup: 'Statistical group',
  businessTypeOfClient: 'Business type of client',
  businessInvolvedInFollowingIndustries: 'Business involved in following industries',
  typeOfRelationship: 'Type of relationship',

  AssessmentIsPassed: 'Assessment is passed.',
  ErrorNotEnoughPoints: "You haven't scored enough points to pass the assessment.",
  ErrorNotOnTime: 'Warning! Time is up, and the test has ended.',

  UndefinedIdDocument: 'Undefined document',
  ID: 'ID',
  Passport: 'Passport',
  Refugee_ID: 'Refugee ID',
  Asylum_Seeker_ID: 'Asylum Seeker ID',
  Refugee_Travel_Document: 'Refugee Travel Document',
  Diplomatic_ID: 'Diplomatic ID',
  Emergency_Travel_Document: 'Emergency Travel Document',
  Military_Identification_Card: 'Military Identification Card',
  Convict_Identification_Card: 'Convict Identification Card',
  Foreign_ID: 'Foreign ID',
  ID_Foreign_Citizen: 'ID Foreign Citizen',
  Driving_Licence: 'Driving Licence',
  Date_must_be_in_past: 'Date must be in past',
  Date_must_be_in_future: 'Date must be in future',
  Date_must_be_less_than: 'Date must be less than',
  Date_must_be_greater_than: 'Date must be greater than',
  Date_must_be_outside_range: 'Date must be outside range',

  /* ---------- */
  /* AGENT NETWORK */
  /* ---------- */
  BasicData: 'Basic data',
  ShortName: 'Short name',
  Address: 'Address',
  Contact: 'Contact',
  AddLocation: 'Add location',
  AddTerminal: 'Add terminal',
  secondaryPhoneNumber: 'Secondary phone number',
  notificationPhoneNumber: 'Notification phone number',
  CreateAgentManual: 'Create agent manual',
  ContactPerson1: 'Contact person 1',
  ContactPerson2: 'Contact person 2',
  TerminalWuCode: 'Terminal WU Code',
  TerminalCertificateNumber: 'Terminal certificate number',
  All_agents: 'All agents',
  Agent_details: 'Agent details',
  Update_agent: 'Update agent',
  CreateAgent: 'Create agent',
  AgentDetails: 'Agent Details',
  UpdateAgent: 'Update agent',
  AgentData: 'Agent Data',
  Financials: 'Financials',
  Services: 'Services',
  Reports: 'Reports',
  Pos: 'Pos',
  Commercial: 'Commercial',
  BusinessDetails: 'Business details',
  Contacts: 'Contacts',
  Documents: 'Documents',
  registrationCountry: 'Registration country',
  formOfOwnership: 'Form of ownership',
  dateEstablished: 'Date established',
  SelectParty: 'Select party',
  PleaseSelectParty: 'Please select party, before fill data.',
  SearchParties: 'Search parties',
  SuccessfullyCreatedAgent: 'Agent created successfully',
  SuccessfullyUpdatedAgent: 'Agent updated successfully',
  NetworkOrganization: 'Network organization',
  SearchAgentsAndLocations: 'Search agents and locations',
  NotFoundAgents: 'Agents not found',
  country: 'Country',
  placeName: 'Place name',
  zipCode: 'Zip Code',
  number: 'Number',
  subNumber: 'Sub number',
  letter: 'Letter',
  floor: 'Floor',
  apartmentNo: 'Apartment No',
  updateContact: 'Update contact',
  addContact: 'Add contact',
  telephoneInfo: 'Telephone info',
  addNewPhoneNumber: 'Add new phone number',
  addressInfo: 'Address info',
  SuccessfullyUpdatedAgentContact: 'Contact updated successfully',
  SuccessfullyCreatedAgentContact: 'Contact created successfully',
  SuccessfullyDeletedAgentContact: 'Contact deleted successfully',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  CLOSED: 'Closed',
  TRANSACTIONAL: 'Transactional',
  PURPOSE: 'Purpose',
  SPECIAL: 'Special',
  REGULAR: 'Regular',
  SAVINGS: 'Savings',
  CREDIT: 'Credit',
  Purpose: 'Purpose',
  AccountStatus: 'Account status',
  AccountType: 'Account type',
  Iban: 'Iban',
  Bban: 'Account number',
  Konto: 'Konto',
  Swift: 'Swift',
  CorrespondentBank: 'Correspondent Bank',
  ForeignPaymentRecipient: 'Foreign Payment Recipient',
  CanBeBlocked: 'Can be blocked',
  PurposeDescription: 'Purpose description',
  Bank: 'Bank',
  CreateAccount: 'Create account',
  UpdateAccount: 'Update account',
  Accounts: 'Accounts',
  SuccessfullyUpdatedAccount: 'Account updated successfully',
  SuccessfullyCreatedAccount: 'Account created successfully',
  SuccessfullyDeletedAccount: 'Account deleted successfully',
  WorkingHours: 'Working hours',
  Commercials: 'Commercials',
  ExternalData: 'External data',
  SuccessfullyCreatedLocation: 'Location successfully created',
  SuccessfullyDeletedLocation: 'Location successfully deleted',
  SuccessfullyUpdatedLocation: 'Location successfully updated',

  /* ---------- */
  /* CURRENCY */
  /* ---------- */
  Currencies: 'Currencies',
  Currency_differences: 'Currency differences',
  Create_currency: 'Create currency',
  Update_currency: 'Update currency',
  Iso_name: 'ISO Name',
  Local_name: 'Local name',
  Local_code: 'Local code',
  Iso_alpha_3: 'ISO Alpha 3',
  Iso_numeric: 'ISO numeric',
  Precision: 'Precision',
  Currency_format: 'Currency format',
  Valid_from: 'Valid from',
  Valid_to: 'Valid to',
  Save_currency: 'Save currency',
  Success_created_currency: 'Successfully created currency',
  Success_updated_currency: 'Successfully updated currency',
  Success_created_currency_denomination: 'Successfully created currency denomination',
  Success_deleted_currency: 'Successfully deleted currency',
  Success_updated_currency_denomination: 'Successfully updated currency denomination',
  Success_deleted_currency_denomination: 'Successfully deleted currency denomination',
  Success_created_currency_country: 'Successfully created relation between currency and country',
  Success_deleted_currency_country: 'Successfully deleted relation between currency and country',
  Success_updated_currency_country: 'Successfully updated relation between currency and country',
  Serial_number_format: 'Serial number format',
  Denomination_value: 'Denomination value',
  Banknote: 'Banknote',
  Is_banknote: 'Is banknote?',
  Comment: 'Comment',
  No_comment: 'No entered comment',
  Create_currency_denomination: 'Create denomination',
  Update_currency_denomination: 'Update denomination',
  List_currency_denominations: 'List denominations',
  Details_currency_denomination: 'Details currency denomination',
  Currency_denomination: 'Denomination',
  Are_you_sure: 'Are you sure?',
  Are_you_sure_deactivate_currency_denomination: 'Are you sure deactivate denomination?',
  In_use_from: 'In use from',
  In_use_to: 'In use to',
  Create_currency_country: 'Create relation between currency and country',
  List_currency_countries: 'List currency countries',
  Update_currency_country: 'Update relation between currency and country',
  Details_currency_country: 'Details currency country',
  Active: 'Active',
  Inactive: 'Inactive',
  Are_you_sure_deactivate_currency_country: 'Are you sure deactivate currency country relation?',
  Are_you_sure_deactivate_currency: 'Are you sure deactivate currency?',
  Save_currency_denomination: 'Save currency denomination',
  Details_currency: 'Details currency',
  Changed_value_to: 'Changed value to',
  Success_saved_currency_list_changes: 'Successfully saved currency list changes',
  Update_changes: 'Update changes',
  Deactivated: 'Deactivated',
  Currency_iso_3_name: 'Currency Iso 3 name',
  Country_iso_3_name: 'Country Iso 3 name',
  Currency_country_differences: 'Currency country differences',

  // Time zone
  Time_zone: 'Time zone',
  Time_zone_names: 'Time zone names',
  Abbreviations: 'Abbreviations',
  Current_time_zone: 'Current time zone',

  // Country
  Create_country: 'Create country',
  Update_country: 'Update country',
  Details_country: 'Details country',
  Iso_alpha_2: 'ISO Alpha 2',
  Iso_numeric_code: 'ISO Numeric code',
  Platform_provider_country: 'Platform provider country',
  Save_country: 'Save country',
  Success_updated_country: 'Successfully updated country',
  Success_created_country: 'Successfully created country',
  Success_deleted_country: 'Successfully deleted country',
  List_countries: 'List countries',

  // TIME MANAGEMENT
  Initialize_year: 'Initialize year',
  Connect_year_with_country: 'Connect year with country',
  Define_calendar_for_country: 'Define calendar for country',
  Review_calendar_by_countries: 'Review calendar by countries',

  // Place
  Create_place: 'Create place',
  Save_place: 'Save place',
  Details_place: 'Details place',
  List_places: 'List places',
  Update_place: 'Update place',
  Code: 'Code',
  Sub_code: 'Sub code',
  English_name: 'English name',
  Geo_longitude: 'Geo Longitude',
  Geo_latitude: 'Geo Latitude',
  Success_created_place: 'Successfully created place',
  Success_updated_place: 'Successfully updated place',
  Success_deleted_place: 'Successfully deleted place',

  /* ---------- */
  /*  PriceList */
  /* ---------- */
  Bank_price_lists: 'Bank pricelists',
  Bank_price_list: 'Bank pricelist',
  Choose_bank: 'Choose bank',
  Amount_to: 'Amount to',
  Amount_from: 'Amount from',
  Orders_to: 'Orders to',
  Orders_from: 'Orders from',
  Bank_price_list_details: 'Bank_price_list_details',
  Attribute: 'Attribute',
  Allowed_values: 'Allowed values',
  Pricelists: 'Pricelists',
  Agents_list: 'Agents list',
  Clients_list: 'Clients list',
  Locations_list: 'Locations list',
  Assign: 'Assign',
  Price_list_type: 'Pricelist type',
  Price_list_status: 'Pricelist status',
  Assign_to_all: 'Assign to all',
  Assign_price_list: 'Assign pricelist',
  All_price_lists: 'All pricelists',
  Price_list_details: 'Pricelist details',
  Fixed_fee: 'Fixed fee',
  Minimal_fee: 'Minimal fee',
  Maximal_fee: 'Maximal fee',
  Percentage_fee: 'Percentage fee',
  Price_list_definition: 'Pricelist definition',
  Pricelist_item: 'Pricelist item',
  Pricelist_items: 'Pricelist items',
  Pricelist_name: 'Pricelist name',
  Create_pricelist: 'Create pricelist',
  Pricelist_status: 'Pricelist status',
  Pricelist_details: 'Pricelist details',
  Price_list_items: 'Pricelist items',
  Price_list_items_values: 'Pricelist item values',
  Show_state_changes: 'Show state changes',
  Hide_state_changes: 'Hide state changes',
  Pricelist_description: 'Pricelist description',
  Update_price_list_items: 'Update pricelist items',
  Update_price_list_definition: 'Update pricelist definition',
  Price_list_states_change_history: 'Pricelist states change history',
  Price_list_updated_successfully: 'Pricelist updated successfully',
  Price_list_deleted_successfully: 'Pricelist deleted successfully',
  Price_list_created_successfully: 'Pricelist created successfully',
  Price_list_definition_updated_successfully: 'Pricelist definition updated successfully',
  Price_list_items_updated_successfully: 'Pricelist items updated successfully',
  Finish_creating: 'Finish creating',
  Use_as_template: 'Use as template',
  Finish_setting_definition: 'Finish setting definition',
  Price_list_finished_forming_successfully: 'Pricelist finished forming successfully',
  Price_list_deactivated_successfully: 'Pricelist deactivated successfully',
  Price_list_assigned_successfully: 'Pricelist assigned successfully',
  Price_list_finished_creating_successfully: 'Pricelist finished creating successfully',
  Price_list_finished_setting_definition_successfully:
    'Pricelist finished setting definition successfully',

  // Sharing arrangement
  Sharing_arrangement_model: 'Sharing arrangement model',
  Sharing_arrangement_models: 'Sharing arrangement models',
  Create_new_model: 'Create new models',
  Counter_reset_period: 'Counter reset period',
  State_type: 'State type',
  Success_updated_sharing_arrangement_model: 'Successfully updated sharing arrangement models',
  Criterion_parameters: 'Parameters',
  Add_item: 'Add item',
  No_entered_items: 'No entered items',
  No_entered_criterias: 'No entered criterias',
  Add_new_criterion: 'Add new criterion',
  Entered_multiple_range_parameters: 'It is not allowed to enter more than one range parameter',
  Fixed_commission: 'Fixed commission',
  Percentage_commission: 'Percentage commission (%)',
  Minimal_commission: 'Minimal commission',
  Maximal_commission: 'Maximal commission',
  Success_updated_criterion: 'Successfully updated parameters',
  Success_updated_items: 'Successfully updated items',
  Value_to: 'Value to',
  Value_from: 'Value from',
  State_machine: 'State machine',
  Return_to_update: 'Return to update',
  Success_closed_model: 'Successfully closed models',
  Success_activated_model: 'Successfully activated models',
  Success_deactivated_model: 'Successfully deactivated models',
  Success_requested_deactivation_model: 'Successfully requested deactivation models',
  Success_created_model: 'Successfully created sharing arrangement models',
  Success_deleted_model: 'Successfully deleted sharing arrangement models',
  Success_finish_creating_model: 'Successfully finish creating models',
  Success_finish_forming: 'Successfully finish forming models',
  Success_finish_parametrizing_model: 'Successfully finish parametrizing models',
  Success_return_model_for_update: 'Successfully returned models for update',
  Request_deactivation: 'Request deactivation',
  Real_time: 'Real time',
  Sharing_arrangement_model_type: 'Sharing arrangement models type',
  Sharing_arrangement_agent_model: 'Agent models',
  Sharing_arrangement_service_provider_model: 'Service provider models',
  Update_sharing_arrangement_model: 'Update sharring arrangement models',
  Sharing_arrangement_model_states_change_history:
    'Sharing arrangement models states change history',
  Is_real_time: 'Is real time',
  Min_commission: 'Min commission',
  Max_commission: 'Max commission',
  Perc_commission: '% commission',
  Minimum_length_is: 'Minimum lenght is',
  Parameter: 'Parameter',

  /* ---------- */
  /*  SETTINGS  */
  /* ---------- */
  Add_payment_method_to_agent: 'Add payment method to agent',
  Choose_payment_method: 'Choose payment method',
  Service_types_list: 'Service types list',
  Currency_list: 'Currency list',
  Till_settings: 'Till settings',
  General_settings: 'General settings',
  Till_opening_mode: 'Till opening mode',
  Till_currency_denomination: 'Currency denomination',
  Updated_requirements_successfully: 'Updated requirements successfully',
  Set_till_configuration_successfully: 'Till configuration updated successfully',

  /* ---------- */
  /*    RISK    */
  /* ---------- */
  Debt: 'Debt',
  All_debt_limits: 'All debt limits',
  Debt_limit: 'Debt limit',
  Create_debt_limit: 'Create Debt Limit',
  Limit_models: 'Limit models',
  Planned_increase: 'Planned increase',
  Applies_to: 'Applies to',
  Refers_to: 'Refers to',
  Model_applies_to: 'Model applies to',
  Model_refers_to: 'Model refers to',
  Debt_limit_model_created_successfully: 'Debt limit models created successfully',
  Debt_limit_details: 'Debt limit details',
  Model_info: 'Model info',
  Approve_model: 'Approve models',
  Reject_model: 'Reject model',
  Delete_model: 'Delete model',
  Deactivate_model: 'Deactivate models',
  Invoke_type: 'Invoke type',
  User_invokes: 'User invokes',
  Creation_invoke: 'Creation invoke',
  Deletion_invoke: 'Deletion invoke',
  Deactivation_invoke: 'Deactivation invoke',
  Resolved_date: 'Resolved date',
  Add_planned_increase: 'Add planned increase',
  Remove_planned_increase: 'Remove planned increase',
  Asign_to_agents: 'Asign to agents',
  Reasign_from_agent: 'Reasign from agent',
  Remove_assignment_invoke: 'Remove assignment invoke',
  Add_service_support_invoke: 'Add service support invoke',
  Remove_service_support_invoke: 'Remove service support invoke',
  Assignment_invoke: 'Assignment invoke',
  Planned_increase_limit_invoke: 'Planned increase limit invoke',
  Created_delete_debt_model_invoke_successfully: 'Created delete debt models invoke successfully',
  Rejected_debt_limit_deletion_successfully: 'Rejected debt limit deletion successfully',
  Created_debt_limit_model_assignment_successfully: 'Created debt limit assignment successfully',
  Rejected_debt_limit_assignment_successfully: 'Rejected debt limit assignment successfully',
  Approved_debt_limit_assignment_successfully: 'Approved debt limit assignment successfully',
  Created_debt_limit_model_resignment_successfully: 'Created debt limit resignment successfully',
  Approved_debt_limit_resignment_successfully: 'Approved debt limit resignment successfully',
  Rejected_debt_limit_resignment_successfully: 'Rejected debt limit resignment successfully',
  Created_debt_limit_deactivation_invoke_successfully:
    'Created debt limit deactivation invoke successfully',
  Approved_debt_limit_deactivation_successfully: 'Approved debt limit deactivation successfully',
  Rejected_debt_limit_deactivation_successfully: 'Rejected debt limit deactivation successfully',
  Rejected_debt_limit_planned_increase_addition_successfully:
    'Rejected debt limit planned increase addition successfully',
  Approved_debt_limit_planned_increase_addition_successfully:
    'Approved debt limit planned increase addition successfully',
  Planned_increase_management: 'Planned increase management',
  Planned_increases_list: 'Planned increases list',
  Period: 'Period',
  Increase: 'Increase',
  Monthly: 'Monthly',
  Active_only: 'Active only',
  Valid_due: 'Valid due',
  Create_planned_increase: 'Create planned increase',
  Created_planned_increase_successfully: 'Created planned increase successfully',
  Invoked_by: 'Invoked by',
  Invoked_date: 'Invoked date',
  Resolved_by: 'Resolved by',
  Assigning_to_agent: 'Assigning to agent',
  Resigning_from_agent: 'Resigning from agent',
  Increase_amount: 'Increase amount',
  Base_amount: 'Base amount',
  On_days: 'On days',
  Days: 'Days',
  Periods: 'Periods',
  Period_from: 'Period from',
  Period_to: 'Period to',
  Add_period: 'Add period',
  On_periods: 'On periods',
  Delete_period: 'Delete period',
  Month_days: 'Month days',
  Add_month_day: 'Add month days',
  Day: 'Day',
  Every: 'Every',
  Of_month: 'Of month',

  // Agent risk
  Risk_info: 'Risk info',
  Risk_type: 'Risk type',
  Agent_risk: 'Agent risk',
  Agent_risks: 'Agent risks',
  All_agent_risks: 'All agent risks',
  Service_support: 'Service support',
  Add_support_for: 'Add support for',
  Agent_risk_type: 'Agent risk type',
  Default_currency: 'Default currency',
  Assign_to_agents: 'Assign to agents',
  Create_agent_risk: 'Create agent risk',
  Remove_support_for: 'Remove support for',
  Agent_risk_details: 'Agent risk details',

  // Agent debt limit
  Agent_debt: 'Agent debt',
  Down_payments: 'Down payments',
  Base_debt_limit: 'Base debt limit',
  Agent_debt_limit: 'Agent debt limit',
  Temporary_increases: 'Temporary increases',
  All_agent_debt_limits: 'All agent debt limits',
  Agent_debt_limit_details: 'Agent debt limit details',
  Create_temporary_increase: 'Create temporary increase',
  Temporary_increase_management: 'Temporary increase management',

  FirstDayOfMonth: 'Every first day of month',
  FirstWorkingDayOfMonth: 'Every first working day of month',
  LastDayOfMonth: 'Every last day of month',
  LastWorkingDayOfMonth: 'Evert last working day of month',
  CertainDayOfMonth: 'Certain day of month',
  DayInFirstWeekOfMonth: 'Day in first week of month',
  DayInSecondWeekOfMonth: 'Day in second week of month',
  DayInThirdWeekOfMonth: 'Day in third week of month',
  DayInFourthWeekOfMonth: 'Day in fourth week of month',
  DayInFifthWeekOfMonth: 'Day in fifth week of month',

  DayInFirstWeekOfMonth_label: 'In first week of month',
  DayInSecondWeekOfMonth_label: 'In second week of month',
  DayInThirdWeekOfMonth_label: 'In third week of month',
  DayInFourthWeekOfMonth_label: 'In fourth week of month',
  DayInFifthWeekOfMonth_label: 'In fifth week of month',

  /* -------------- */
  /*   SETTLEMENT   */
  /* -------------- */
  Master_agents_list: 'Master agents list',
  Iso_code: 'ISO code',
  Is_domicile: 'Is domicile',
  repeat_every: 'Repeat every',
  End_time: 'End time',
  Start_time: 'Start time',
  Repeat_every: 'Repeat every',
  Netting: 'Netting',
  BBAN: 'BBAN',
  Settlement_settings: 'Settlement settings',
  Settlement_execution_plan: 'Settlement execution plan',
  Basic_settlement_configuration: 'Basic settlement configuration',
  Settlement_basic_configuration_created_successfully:
    'Settlement basic configuration created successfully',
  Settlement_basic_configuration_updated_successfully:
    'Settlement basic configuration updated successfully',
  Settlement_added_agent_account_successfully: 'Settlement added agent account successfully',
  Settlement_added_master_agent_account_successfully:
    'Settlement added master agent account successfully',
  Settlement_removed_agent_account_successfully: 'Settlement removed agent account successfully',
  Settlement_removed_master_agent_account_successfully:
    'Settlement removed master agent account successfully',

  Settlement_amount_parameters: 'Settlement amount parameters',
  Create_parameter: 'Create parameter',
  Amount_parameters: 'Amount parameters',
  Amount_parameters_list: 'Amount parameters list',
  Exchange_rate_type: 'Exchange rate type',
  Exchange_rate_date: 'Exchange rate date',
  Is_for_all_currency: 'Is for every currency',
  Should_include_fee: 'Should include fee',

  Create_amount_parameter: 'Create amount parameter',
  Update_amount_parameter: 'Update amount parameter',
  Create_settlement_amount_parameter: 'Create settlement amount parameter',
  Update_settlement_amount_parameter: 'Update settlement amount parameter',
  Settlement_amount_parameter_created_successfully:
    'Settlement amount parameter created successfully',
  Settlement_amount_parameter_updated_successfully:
    'Settlement amount parameter updated successfully',

  None: 'None',
  Pay_in: 'Pay in',
  Pay_out: 'Pay out',

  Amount_criteria: 'Amount criteria',

  Due_date_configuration: 'Due date configuration',
  Due_date_configurations: 'Due date configurations',
  Settlement_due_date_configurations: 'Settlement due date configurations',
  Due_date_configuration_list: 'Due date configuration list',
  Create_configuration: 'Create configuration',
  Create_settlement_due_date_configuration: 'Create settlement due date configuration',
  For_service: 'For service',
  For_sub_service: 'For sub service',
  Transaction_part_type: 'Transaction part type',
  Settlement_type: 'Settlement type',
  Settlement_due_date_configuration_created_successfully:
    'Settlement due date configuration created successfully',
  Amount_with_rolling: 'Amount with rolling',
  Amount_with_accounting: 'Amount with accounting',
  Settlement_due_date_configuration_details: 'Settlement due date configuration details',
  All_settlement_due_date_configuration_activated_successfully:
    'All settlement due date configuration activated successfully',
  Settlement_due_date_configuration_activated_successfully:
    'Settlement due date configuration activated successfully',
  All_settlement_due_date_configuration_deactivated_successfully:
    'All settlement due date configuration deactivated successfully',
  Settlement_due_date_configuration_deactivated_successfully:
    'Settlement due date configuration deactivated successfully',
  Settlement_due_date_configuration_deleted_successfully:
    'Settlement due date configuration deleted successfully',
  Amount_parameter: 'Amount parameter',
  Configuration_type: 'Configuration type',
  Delete_configuration: 'Delete configuration',
  Per_currency: 'Per currency',
  Additional_info: 'Additional info',
  Agent_info: 'Agent info',
  Agent_name: 'Agent name',
  Agent_registry_code: 'Agent registry code',
  Agent_tax_number: 'Agent tax number',
  Add_netting: 'Add netting',
  Add_currency: 'Add currency',
  Add_settlement_netting_setting: 'Add settlement netting setting',
  Add_settlement_currency_setting: 'Add settlement currency setting',

  Netting_type: 'Netting type',

  Principal: 'Principal',
  Agent_service_list: 'Agent service list',

  Settlement_configuration_deleted_successfully: 'Settlement configuration deleted successfully',
  Settlement_configuration_updated_successfully: 'Settlement configuration updated successfully',
  Settlement_configuration_finished_successfully: 'Settlement configuration finished successfully',
  Settlement_configuration_activated_successfully:
    'Settlement configuration activated successfully',
  Settlement_configuration_unfinished_successfully:
    'Settlement configuration unfinished successfully',
  Settlement_configuration_deactivated_successfully:
    'Settlement configuration deactivated successfully',

  Due_date_type: 'Due date type',
  Periodic_month: 'Periodic month',
  Periodic_quarter: 'Periodic quarter',
  Periodic_weekdays: 'Periodic weekdays',
  Periodic_year: 'Periodic year',
  T_plus_n: 'T plus n',

  Due_date: 'Due date',
  Month_of_year: 'Month of year',
  Day_of_the_week: 'Day of the week',
  Day_of_the_month: 'Day of the month',
  Service_info: 'Service info',
  Parameter_value: 'Parameter value',
  Parameter_values: 'Parameter values',
  Parameters: 'Parameters',
  Amount_limit: 'Amount limit',

  Settlement_configuration: 'Settlement configuration',
  Settlement_configurations: 'Settlement configurations',
  Settlement_configuration_list: 'Settlement configuration list',
  Create_settlement_configuration: 'Create settlement configuration',
  Update_settlement_configuration: 'Update settlement configuration',

  Settlement_configuration_created_successfully: 'Settlement configuration created successfully',

  Netting_enabled: 'Netting enabled',
  Settlement_date: 'Settlement date',
  Transaction_date: 'Transaction date',
  Settlement_cycles: 'Settlement cycles',
  Settlement_setting: 'Settlement setting',
  Settlement_currency: 'Settlement currency',
  On_working_day_only: 'On working day only',
  Periodic_settlement_plan: 'Predefined',
  Continuous_settlement_plan: 'Recurring',

  Finnancial_part: 'Finnancial part',

  Settlement_setting_created_successfully: 'Settlement setting created successfully',
  Settlement_setting_updated_successfully: 'Settlement setting updated successfully',

  Save_as_template: 'Save as template',
  Basic_information: 'Basic information',

  Multi_service_netting: 'Multi service netting',
  Single_service_netting: 'Single service netting',
  Configuration_items: 'Configuration items',
  MA_account: 'MA account',

  All_and_all: 'All and all',
  Fee_and_commision: 'Fee and commision',
  Principal_and_principal: 'Principal and principal',

  Created_settlement_configuration_template_successfully:
    'Created settlement configuration template successfully',

  Settlement_configuration_details: 'Settlement configuration details',

  WU_record_types: 'WU record types',
  WU_record_types_list: 'WU record types list',
  Create_WU_record_type: 'Create record type',
  Update_WU_record_type: 'Update record type',

  WU_adjustment_reason_codes: 'WU adjustment reason codes',
  WU_adjustment_reason_codes_list: 'WU adjustment reason codes list',
  Create_WU_adjustment_reason_code: 'Create adjustment reason code',

  Create_record_type: 'Create record type',
  Update_record_type: 'Update record type',
  WU_record_type_created_successfully: 'WU record type created successfully',
  WU_record_type_updated_successfully: 'WU record type updated successfully',
  WU_record_type_deleted_successfully: 'WU record type deleted successfully',

  MTCN_ref: 'MTCN ref',
  Adjustment_type: 'Adjustment type',
  Full_description: 'Full description',
  Create_adjustment_reason_code: 'Create adjustment reason code',
  Update_adjustment_reason_code: 'Update adjustment reason code',
  Update_WU_adjustment_reason_code: 'Update WU adjustment reason code',
  WU_adjustment_reason_code_created_successfully: 'WU adjustment reason code created successfully',
  WU_adjustment_reason_code_updated_successfully: 'WU adjustment reason code updated successfully',
  WU_adjustment_reason_code_deleted_successfully: 'WU adjustment reason code deleted successfully',

  Reversed: 'Reversed',
  Reprocessed: 'Reprocessed',
  Reversed_and_reprocessed: 'Reversed and reprocessed',

  Manage_accounts: 'Manage accounts',
  Manage_currency: 'Manage currency',
  Manage_netting: 'Manage netting',

  Add_settlement_account_setting: 'Add settlement account setting',
  Add_account: 'Add account',

  Agent_service: 'Agent service',
  Agent_account: 'Agent account',
  Netting_list: 'Netting list',
  Account_list: 'Account list',
  Settlement_netting_setting_added_successfully: 'Settlement netting setting added successfully',
  Settlement_currency_setting_added_successfully: 'Settlement currency setting added successfully',
  Settlement_netting_setting_removed_successfully:
    'Settlement netting setting removed successfully',
  Settlement_currency_setting_removed_successfully:
    'Settlement currency setting removed successfully',
  Settlement_account_setting_removed_successfully:
    'Settlement account setting removed successfully',

  Settlement_account_setting: 'Settlement account setting',
  Settlement_account_setting_list: 'Settlement account setting list',
  Settlement_currency_setting: 'Settlement currency setting',
  Settlement_currency_setting_list: 'Settlement currency setting list',
  Settlement_netting_setting: 'Settlement netting setting',
  Settlement_netting_setting_list: 'Settlement netting setting list',

  Single_service: 'Single service',

  Import: 'Import',
  For_date: 'For date',
  Import_file: 'Import file',
  Is_processed: 'Is processed',
  Activity_files: 'Activity files',
  Import_activity_file: 'Import activity file',
  WU_activity_file_uploaded_successfully: 'WU activity file uploaded successfully',
  WU_activity_file_processed_successfully: 'WU activity file processed successfully',

  Naid: 'NAID',
  File_name: 'File name',
  Processed: 'Processed',

  Settlement_files: 'Settlement files',
  Import_settlement_file: 'Import settlement file',
  WU_settlement_file_uploaded_successfully: 'WU settlement file uploaded successfully',
  WU_settlement_file_processed_successfully: 'WU settlement file processed successfully',

  /* -------------- */
  /*   COMPLIANCE   */
  /* -------------- */
  Add_new_list: 'Add new list',
  Add_category: 'Add category',
  Screening_lists: 'Screening lists',

  Items_matched_by: 'Items matched by',
  Create_screening_list: 'Create screening list',
  Screening_list_information: 'Screening list information',
  Personal_id: 'Personal ID',
  Id_number: 'ID number',
  Date_of_birth: 'Date of birth',
  Remote_client_name: 'Remote client name',

  Add_list_to_category: 'Add list to category',
  New_screening_list_category: 'New screening list category',
  Create_screening_list_category: 'Create screening list category',
  Update_screening_list: 'Update screening list',

  First_name: 'First name',
  Last_name: 'Last name',
  Middle_name: 'Middle name',
  Maternal_name: 'Maternal name',
  Personal_information: 'Personal information',
  Id_country: 'ID, Country',
  Additional_information: 'Additional information',

  Citizenship: 'Citizenship',
  Country_of_birth: 'Country of birth',

  Add_new_rule: 'Add new rule',
  Screening_rules: 'Screening rules',

  /* ---------- */
  /*    DAYS    */
  /* ---------- */
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',

  /* --------------------- */
  /*    USER MANAGEMENT    */
  /* --------------------- */
  Application_types: 'Application types',
  Application_types_list: 'Application types list',
  Application_roles: 'Application roles',
  Application_type: 'Application type',
  Application_id: 'Application id',
  Create_application_role: 'Create application role',
  Create_role_application: 'Create role application',
  Update_application_role: 'Update application role',

  Category_roles: 'Category roles',
  Category_types: 'Category types',
  Category_types_list: 'Category types list',
  Create_role_category: 'Create role category',
  Create_category_role: 'Create category role',
  Update_category_role: 'Update category role',

  Default_role: 'Default role',
  User_management: 'User management',
  Group_name: 'Group name',
  Enabled: 'Enabled',
  Update: 'Update',

  Bank_constraint_statement_is_fulfilled: 'Bank constraint statement is fulfilled',
  Bank_constraint_statement_is_not_fulfilled: 'Bank constraint statement is not fulfilled',

  //
  //
  // Operater App
  //
  //
  Barcode: 'Barcode',
  Printer: 'Printer',
  Language: 'Language',
  Signature: 'Signature',
  Tehnical_support: 'Tehnical support',
  Payment_cards: 'Payment cards',
  Visual_style: 'Visual style',
  Change_TX: 'Change_TX',
  Price_calc: 'Price calc',
  Insurance: 'Insurance',
  Cashdrawer: 'Cashdrawer',
  Pay_status: 'Pay status',
  Request_status: 'Request status',
  Mobile_application: 'Mobile application',
  User_details: 'User details',
  Troubleshooting: 'Troubleshooting',
  Proxy_server: 'Proxy Server',
  New_in_application: 'New In Application',
  Commission: 'Commission',
  Compensation: 'Compensation',
  NBS_daily_report: 'NBS daily report',
  Money_order: 'Money order',
  WU_intra: 'WU intra',
  Western_union: 'Western union',
  Meet_the_client: 'Meet the client',
  WU_com: 'WU_com',

  /* --------------------- */
  /*          TILL         */
  /* --------------------- */
  Till: 'Till',
  Time: 'Time',
  Refund: 'Refund',
  Subtills: 'Subtills',
  Set_limit: 'Set limit',
  To_refund: 'Refund',
  Open_till: 'Open till',
  Close_till: 'Close till',
  Opened_till: 'Opened till',
  Till_states: 'Till states',
  Is_refunded: 'Refunded',
  Closed_till: 'Closed till',
  Coin_balance: 'Coin balance',
  Limit_passed: 'Limit passed',
  General_input: 'General input',
  Refund_reason: 'Refund reason',
  Output_number: 'Output number',
  General_output: 'General output',
  Subtill_limits: 'Subtill limits',
  Internal_input: 'Internal input',
  Set_till_limit: 'set till limit',
  Internal_output: 'Internal output',
  Till_management: 'Till management',
  Banknote_balance: 'Banknote balance',
  Regular_currency: 'Regular currency',
  Execution_deadline: 'Execution deadline',
  Bank_reference_id: 'Bank reference id',
  Process_channel_type: 'Process channel type',
  Transaction_type: 'Transaction type',

  From_last_opening: 'From last opening',
  Till_transactions: 'Till transactions',
  Sub_till_limits_state: 'SubTill limits state',
  Make_till_transaction: 'Make till transaction',
  Output_to_bank_account: 'Output to bank account',
  Input_from_bank_account: 'Input from bank account',
  Error_while_opening_till: 'Error while opening till',
  Till_closed_successfully: 'Till closed successfully',
  Till_opened_successfully: 'Till opened successfully',
  Obsolete_damaged_currency: 'Obsolete/damaged currency',
  Internal_output_for_input: 'Internal output for input',
  Make_till_input_transaction: 'Make till input transaction',
  Make_till_output_transaction: 'Make till output transaction',
  Transaction_created_successfully: 'Transasction created successfully',
  Internal_input_from_exchange_till: 'Internal input from exchange till',
  Success_set_base_debt_limit_agent: 'Successfully updated base debt limit for agent',
  Till_transaction_refunded_successfully: 'Till transaction refunded successfully',
  Success_updated_location_debt_limit_for_currency:
    'Successfully updated location debt limit for currency',

  // Presentation
  Payer_id: 'Payer id',
  Recipient_id: 'Recipient id',
  Recipient_name: 'Recipient name',
  Recipient_type: 'Recipient type',
  Recipient_account: 'Recipient account',

  Balance_amount: 'Balance amount',
  Resolved_amount: 'Resolved amount',
  Settlement_order_date: 'Settlement order date',
  Presentation_demo_page: 'Presentation demo page',

  // Risk
  Go_to_table: 'Go to table',
  Actual_limit: 'Actual limit',
  Location_debt: 'Location debt',
  Service_blocking: 'Service blocking',
  Location_debt_limit: 'Location debt limit',
  Location_debt_risks: 'Location debt risks',
  Debt_risk_by_currency: 'Debt risk by currency',
  Location_debt_risk_name: 'Location debt risk name',
  Create_location_debt_risk: 'Create location debt risk',

  // Teplmates
  Diaries: 'Diaries',
  Edit_template: 'Edit template',
  Apply_template: 'Apply template',
  Update_template: 'Update template',
  Template_groups: 'Template groups',
  Manage_templates: 'Manage templates',
  Template_details: 'Template details',
  Edit_template_group: 'Edit template group',
  Update_template_group: 'Update template group',
  Create_template_group: 'Create template group',
  Template_group_details: 'Template group details',
  Manage_template_groups: 'Manage template groups',
  Finish_managing_templates: 'Finish managing templates',
  Finish_managing_template_groups: 'Finish managing template groups',

  // Settings
  Should_pair_for_internal_transactions: 'Should pair for internal transactions',

  // Terminal settings
  Agent_active: 'Agent active',
  Location_name: 'Location name',
  Location_active: 'Location active',
  Terminal_active: 'Terminal active',
  Update_terminal: 'Update terminal',
  Digital_archive_enabled: 'Digital archive enabled',
  Payment_method_name: 'Payment method name',
  Payments_method_added_successfully: 'Payments method added successfully',
  Payment_method_deleted_successfully: 'Payment method deleted successfully',

  // WU
  Send_money: 'Send money',
  Receive_money: 'Receive money',
  Mtcn: 'MTCN',
  Payout: 'Payout',
  Sender: 'Sender',
  WU_root: 'Western Union',
  Receiver: 'Receiver',
  Transactions: 'Transactions',
  WU_send_money: 'WU send money',
  WU_search_user: 'WU search user',
  Names_do_not_match: 'Names do not match',
  Transactions_table: 'Transactions table',
  Search_and_overview: 'Search and overview',
  Transaction_overview: 'Transaction overview',
  Match_receiver_name: 'Match receiver name',
  WU_search_transaction: 'WU search transaction',
  WU_search_and_overview: 'Search and overview',
  WU_transaction_overview: 'Transaction overview',
  WU_transaction_details: 'WU transaction details',
  Transaction_paid_out_successfully: 'Transaction paid out successfully',

  Destination_country: 'Destination country',
  Sent_amount: 'Sent amount',
  Payout_amount: 'Payout amount',
  Exchange_rate: 'Exchange rate',
  Receiver_information: 'Receiver information',
  Receiver_name: 'Receiver name',
  Receiver_country: 'Receiver country',
  Receiver_city: 'Receiver city',
  Test_question: 'Test question',
  Test_answer: 'Test answer',
  Receiver_country_of_id_issue: 'Receiver country of id issue',
  Sender_country_of_id_issue: 'Sender country of id issue',
  Receiver_id_type: 'Receiver id type',
  Sender_id_type: 'Sender id type',
  Receiver_id_no: 'Receiver id no',
  Sender_id_no: 'Sender id no',
  Receiver_id_issue_date: 'Receiver id issue date',
  Sender_id_issue_date: 'Sender id issue date',
  Receiver_id_date_valid_to: 'Receiver id date valid to',
  Sender_information: 'Sender information',
  Sender_id_date_valid_to: 'Sender id date valid to',
  Sender_amount: 'Sender amount',
  Charges: 'Charges',
  Additional_charges: 'Additional charges',
  Payed_out_amount: 'Payed out amount',
  Sender_id_country_of_issue: 'Sender id country of issue',
  Sender_id_document_no: 'Sender id document no',
  Sender_id_document_issue_date: 'Sender id document issue date',
  Sender_phone: 'Sender phone',
  Sender_city: 'Sender city',
  Sender_name: 'Sender name',
  Sending_amount: 'Sending amount',
  Sender_id_document_type: 'Sender id document type',
  Sender_id_document_expiry_date: 'Sender id document expiry date',
  Current_Exchange_Rate_List: 'Current exchange rate list',
  Create_Main_Exchange_Rate_List: 'Create main exchange rate list',
  Internal_Exhcange_Rate_List: 'Internal exhcange rate list',
  Location_Exchange_Rate_List: 'Location exchange rate list',

  // Esxchange
  Slips: 'Slips',
  Security: 'Security',
  Test_print: 'Test print',
  Test_review: 'Test review',
  Buying_rate: 'Buying rate',
  Selling_rate: 'Selling rate',
  Download_data: 'Download data',
  Integrations: 'Integrations',
  Choosen_currency: 'Choosen currency',
  Purchase_of_coins: 'Purchase of coins',
  Lowest_buying_rate: 'Lowest buying rate',
  Inputs_and_outputs: 'Inputs_and_outputs',
  Highest_selling_rate: 'Highest selling rate',
  Current_internal_list: 'Current internal list',
  Range_should_be_between: 'Range should be between',
  Text_to_print_with_slip: 'Text to print with slip',
  Form_exchange_rate_list: 'Form Exchange Rate List',
  Print_exchange_rate_list: 'Print_exchange_rate_list',
  Create_exchange_rate_list: 'Create exchange rate list',
  Current_list_by_locations: 'Current list by locations',
  'Transaction_amount_(RSD)': 'Transaction amount (RSD)',
  Current_exchange_rate_list: 'Current exchange rate list',
  Publish_exchange_rate_list: 'Publish exchange rate list',
  Internal_exchange_rate_list: 'Internal exchange rate list',
  Purchase_of_damaged_banknotes: 'Purchase of damaged banknotes',
  Purchase_of_uncirculated_banknotes: 'Purchase of uncirculated banknotes',
  Review_and_update_exchange_rate_list: 'Review and update exchange rate list',

  Exchange_Office: 'Exchange Office',
  Main_Exchange_Rate_List: 'Main Exchange Rate List',
  Currency_Code: 'Currency Code',
  Currency_Name: 'Currency Name',
  Lowest_Buying_Rate: 'Lowest Buying Rate',
  Buying_Rate: 'Buying Rate',
  buying_rate: 'buying rate',
  Selling_Rate: 'Selling Rate',
  selling_rate: 'selling rate',
  Highest_Selling_Rate: 'Highest Selling Rate',
  Form_Exchange_Rate_List: 'Form Exchange Rate List',
  Locations: 'Locations',
  Selected_Locations: 'Selected Locations',
  Updated_Locations: 'Updated Locations',
  Please_select_locations_to_update: 'Please select locations to update',
  Locations_not_updated_yet: 'Locations not updated yet',
  Save_Internal_List_By_Locations: 'Save Internal List By Locations',
  Main_list: 'Main list',
  List_of_favorable_exchange_rates: 'List of favorable exchange rates',
  List_with_minimum_and_maximum_values: 'List with minimum and maximum values',
  Expanded_list_with_minimum_and_maximum_values: 'Expanded list with minimum and maximum values',
  Official_NBS_rates: 'Official NBS rates',
  NBS_rates_overview: 'NBS rates overview',
  Choosen_Currency: 'Choosen Currency',
  Location_list_fetched_successfully: 'Location list fetched successfully',
  Ooops_something_went_wrong: 'Ooops something went wrong!',
  Buying_Global_Rate: 'Buying Global Rate',
  Selling_Global_Rate: 'Selling Global Rate',
  Middle_Exchange_Rate_NBS: 'Middle Exchange Rate NBS',
  Change_on_all_locations: 'Change on all locations',
  Form_Main_Exchange_Rate_List: 'Form Main Exchange Rate List',
  Save_main_exchange_rate_list: 'Save main exchange rate list',
  Exchange_rates_fetched_successfully: 'Exchange rates fetched successfully',
  Main_exchange_rate_list_fetched_successfully: 'Main exchange rate list fetched successfully',
  "Ooops_something_went_wrong,_couldn't_fetch_available_rates":
    "Ooops something went wrong, couldn't fetch available rates",
  Buying_Offset: 'Buying Offset',
  Selling_Offset: 'Selling Offset',
  Offset_type: 'Offset type',
  Offset_Type: 'Offset Type',
  Change_all_rates: 'Change all rates',
  Main_Exchange_Rate_List_Offsets: 'Main Exchange Rate List Offsets',
  Save_offsets: 'Save offsets',
  Succeessfully_fetched_exchange_rate_offsets: 'Succeessfully fetched exchange rate offsets',
  "Something_went_wrong,_couldn't_fetch_Exchange_Rate_Offsets":
    "Something went wrong, couldn't fetch exchange rate offsets",
  Successfully_fetched_internal_rates: 'Successfully fetched internal rates',
  Set_to_zero: 'Set to zero',
  Set_to_main_rate: 'Set to main rate',
  Set_as_main_list: 'Set as main list',
  Internal_Exchange_Rate_List: 'Internal Exchange Rate List',
  Save_internal_rates: 'Save internal rates',
  Internal_exchange_rate_list_created: 'Internal exchange rate list created',
  Main_exchange_rate_list_created: 'Main exchange rate list created!',
  Location_exchange_rate_list_updated: 'Location exchange rate list updated',
  Exchange_rate_list_updated: 'Exchange rate list updated',
  Difference_should_be_in_range_between: 'Difference should be in range between',
  Value_should_be_in_range_between: 'Value should be in range between',
  and: 'and',
  Purchase_Of_Damaged_Banknotes: 'Purchase Of Damaged Banknotes',
  Purchase_Of_Uncirculated_Banknotes: 'Purchase Of Uncirculated Banknotes',
  Purchase_Of_Coins: 'Purchase Of Coins',
  Confirmations: 'Confirmations',
  Ulazi_i_izlazi: 'Ulazi i izlazi',
  Commercial_bank_exchange_rate: 'Commercial bank exchange rate',
  Change_offsets_based_on_middle_exchange_rate_NBS:
    'Change offsets based on middle exchange rate NBS',
  Buying_rate_offset: 'Buying rate offset',
  Selling_rate_offset: 'Selling rate offset',
  Middle_exchange_rate_NBS: 'Middle exchange rate NBS',
  'The_NBS_exchange_for_cash_tranastions_(Effective)_and_the_middle_rate_for_other_currencies':
    'The NBS exchange for cash tranastions (Effective) and the middle rate for other currencies',
  'Previous_values_(Previous_list_settings)': 'Previous values (Previous list settings)',
  Basis_when_creating_exchange_rate_list: 'Basis when creating exchange rate list',
  Internal_List_Settings_Based_on_Main_Rate: 'Internal List Settings Based on Main Rate',
  Show_only_active_rates: 'Show only active rates',
  Value_is_not_in_the_provided_range: 'Value is not in the provided range',
  Currency_subtypes_updated_successfully: 'Currency subtypes updated successfully',
  Internal_rate_updated_successfully: 'Internal rate updated successfully',
  Official_NBS_list: 'Official NBS list',
  LISTS_HISTORY: 'LISTS HISTORY',
  Print_date_and_time_on_list: 'Print date and time on list',
  Print_current_date_on_main_list: 'Print current date on main list',
  'Main_exchange_rate_list_(text_line_below_list)':
    'Main exchange rate list (text line below list)',
  'Commision_list_(text_line_below_list)': 'Commision list (text line below list)',
  'Minimum_and_maximum_amounts_(text_line_below_list)':
    'Minimum and maximum amounts (text line below list)',
  Print_accounting_exchange_rate_report_separately_by_conditions:
    'Print accounting exchange rate report separately by conditions',
  'Reports_by_location_(exchange_place)': 'Reports by location (exchange place)',
  'Sort_JOURNAL_in_descending_order_(last on top)':
    'Sort JOURNAL in descending order (last on top)',
  'Journal_transactions_by_location_(exchange_place)_/_for_worker':
    'Journal transactions by location (exchange place) / for worker',
  'Slip_start_ext_(e.g._company_name)': 'Slip start text (e.g. company name)',
  'Slip_end_text_(e.g._Thanks...)': 'Slip end text (e.g. Thanks...)',
  Print_application_name: 'Print application name',
  Additional_slip_with_confirmation: "Additional 'slip' with confirmation",
  Print_if_conditions_are_met: 'Print if conditions are met',
  'Connected_internal_inputs_and_outputs_(internal_output_must_match_internal)':
    'Connected internal inputs and outputs (internal output must match internal)',
  In_local_mode_do_not_connect_internal_inputs_to_enable_synchronization:
    'In local mode do not connect  internal inputs to enable synchronization',
  Allow_exchange_rate_input_when_creating_internal_inputs_and_outputs:
    'Allow exchange rate input when creating internal inputs and outputs',
  Do_nothing: 'Do nothing',
  Ask_for_input_to_another_till: 'Ask for input to another till',
  Automatically_add_another_input_to_till: 'Automatically add another input to till',
  Print_denomination_structure_during_internal_outputs:
    'Print denomination structure during internal outputs',
  Print_denomination_structure_while_handing_it_over_to_the_bank:
    'Print denomination structure while handing it over to the bank',
  Print_denomination_structure_during_outputs_to_till:
    'Print denomination structure during outputs to till',
  Mandatory_denomination_structure_for_transactions_in_EUR:
    'Mandatory denomination structure for transactions in EUR',
  Mandatory_denomination_structure_for_outputs_and_inputs_in_EUR:
    'Mandatory denomination structure for outputs and inputs in EUR',
  Specification_print_settings: 'Specification print settings',
  'On_the_printer_for_confirmations_(narrower_format_in_the_width_of_the_confirmation)':
    'On the printer for confirmations (narrower format in the width of the confirmation)',
  'On_the_report_printer_(A4_format)': 'On the report printer (A4 format)',
  'Employee_(managers)_restrictions_by_regions_(locations)_and_operations':
    'Employee (managers) restrictions by regions (locations) and operations',
  Integration_with_the_accounting_system: 'Integration with the accounting system',
  Integration_type: 'Integration type',
  'From_(RSD)': 'From (RSD)',
  'To_(RSD)': 'To (RSD)',
  Text: 'Text',
  Server_address: 'Server address',
  Review_data_before_sending: 'Review data before sending',
  Select_slip_to_edit_or_delete: 'Select slip to edit or delete',
  Consolidated_cash_journal_in_vertical_format_for_smaller_currencies:
    'Consolidated cash journal in vertical format for smaller currencies',
  Reports_in_new_format: 'Reports in new format',
  Internal_transfers_between_payment_and_exchange_office_till_After_creating_output:
    'Internal transfers between payment and exchange office till After creating output',
  User_name: 'User name',
  Name_and_last_name: 'Name and last name',
  Responsibilities: 'Responsibilities',
  Denomination_structure: 'Denomination structure',

  // Payment order
  Vouchers: 'Vouchers',
  Daily_sales: 'Daily sales',
  Final_submit: 'Final submit',
  Cart_is_empty: 'Cart is empty',
  Cart_checkout: 'Cart checkout',
  Payment_order: 'Payment order',
  Create_new_cart: 'Create new cart',
  Hide_templates: 'Hide templates',
  Risk_managment: 'Risk managment',
  Show_templates: 'Show templates',
  '< Continue_entry': '< Continue_entry',
  Presentation_review: 'Presentation review',
  Domestic_money_order: 'Domestic money order',
  Money_order_domestic: 'Money order domestic',
  Money_order_international: 'Money order domestic',
  Look_like_you_have_no_items_in_your_cart: 'Look like you have no items in your cart',
  requiredField: 'Obavezno polje',
  Invalid_date: 'Invalid date',
} as const;

export type ICommonEN = typeof commonEN;
export type ICommonENKey = keyof typeof commonEN;
